'use client';

import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { getTranslations } from '@/lib/i18n';

interface ContactFooterProps {
  className?: string;
}

export default function ContactFooter({ className = '' }: ContactFooterProps) {
  const { language } = useLanguage();
  const t = getTranslations(language);

  return (
    <div className={`flex items-center justify-center py-4 px-4 ${className}`}>
      <a
        href="mailto:info@rezora.com.cy"
        className="inline-flex items-center gap-1.5 text-xs transition-all duration-150 hover:brightness-110"
        style={{ color: '#9ca3af' }}
        onMouseEnter={(e) => { e.currentTarget.style.color = '#C9A84C'; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = '#9ca3af'; }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect width="20" height="16" x="2" y="4" rx="2" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
        <span>{(t as any)?.common?.contactUs ?? (t as any)?.[0]?.common?.contactUs ?? 'Contact Us'}</span>
        <span style={{ color: '#4b5563' }}>·</span>
        <span style={{ color: '#C9A84C' }}>info@rezora.com.cy</span>
      </a>
    </div>
  );
}
